<template>
  <!--解决方案页面-->
  <div class="companyProfile">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="imgBoxUrl" class="el-image__inner">
      </div>

    </div>
    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>
    <div class="menuBox"></div>
    <!--    内容-->
    <div class="contentBox" v-show="item.showData" v-for="item in itemData">
      <div class="contentTitle">
        {{item.text1}}
      </div>
      <div class="contentImg">
        <div class="leftImg">
          <el-image
            style="width: 578px; height: 700px"
            :src="item.img1"
            :fit="contain"></el-image>
        </div>
        <div class="rightImg">
          <div class="rightTopImg">
            <el-image
              style="width: 578px; height: 340px"
              :src="item.img2"
              :fit="contain"></el-image>
          </div>
          <div class="rightBottomImg">
            <div class="rightTopImg">
              <el-image
                style="width: 578px; height: 340px"
                :src="item.img3"
                :fit="contain"></el-image>
          </div>
        </div>
</div>
      </div>
      <div class="contentDetail">
        <div class="itemContent" >
          {{item.text2}}
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import Mun2 from "./image/mun2";
export default {
  name: "companyProfile",
  components: {Mun2},
  data() {
    return {
      imgBoxUrl:"http://116.62.38.250//image//nr/tp/jjfa.jpg",
      urlData:"",
      showData:{
        box1: false
      },
      numIndex: "1",
      numList : [
        {
          num : "1",
          tital : "For Hospitals/Departments",
          path: "dyy"
        },
        {
          num : "2",
          tital : "For Doctors",
          path: "dys"
        },{
          num : "3",
          tital : "For Patients",
          path: "dhz"
        }
      ],
      itemData:[{
        num : "1",
        path: "dyy",
        showData:false,
        img1:"http://116.62.38.250//image/nr/jjfa/1.jpg",
        img2:"http://116.62.38.250//image/nr/jjfa/2.jpg",
        img3:"http://116.62.38.250//image/nr/jjfa/3.jpg",
        text1:"Comfortable Diagnosis and Treatment Center",
        text2:"Enhancing Competitiveness: Establishing a specialty in laser treatment can help hospitals or departments differentiate themselves in their field, creating a reputation for being technologically and academically advanced. This not only enhances the hospital's or department’s image but also elevates its academic standing.\n" +
          "Increasing Economic Benefits: Dental laser treatment has specific billing codes, and due to the high patient acceptance of such treatments, hospitals and departments can generate increased revenue.\n" +
          "Promoting Research and Education: Laser treatment provides numerous opportunities for scientific research and practical application, laying the foundation for more innovative research projects and outcomes. It also supports educational efforts by providing advanced technology for training future professionals.\n" +
          "Optimizing Treatment Outcomes: The precision and effectiveness of dental laser treatments improve the department’s capability to treat a variety of oral diseases. Procedures such as laser-assisted dental implants, periodontal disease treatment, and root canal therapy provide higher-quality care, boosting patient satisfaction and trust in the hospital or department."
      },
        {
          num : "2",
          path: "dys",
          showData:false,
          img1:"http://116.62.38.250//image/nr/jjfa/1.jpg",
          img2:"http://116.62.38.250//image/nr/jjfa/2.jpg",
          img3:"http://116.62.38.250//image/nr/jjfa/3.jpg",
          text1:"Comfortable Diagnosis and Treatment Center",
          text2:"Enhancing Professional Skills: Mastering dental laser technology expands the range of treatment options available to doctors, enriching their professional knowledge and skill set. This makes them more competitive within their field.\n" +
            "Increasing Career Opportunities: Dental laser treatment is an emerging area in both academic and clinical research. By engaging in related studies and publishing research findings, doctors can gain more opportunities for career advancement and academic recognition.\n" +
            "Improving Treatment Outcomes: The precision and effectiveness of laser treatments enable doctors to achieve better clinical results. In some cases, laser procedures can be performed more efficiently compared to traditional methods, increasing overall productivity.\n" +
            "Creating a Safer Work Environment: Er:YAG lasers significantly reduce aerosol production by up to 98% compared to traditional dental turbines, making the working environment safer and more conducive for doctors.\n" +
            "Boosting Patient Satisfaction: The superior treatment outcomes and enhanced patient experience provided by laser technology increase patient satisfaction and trust, helping doctors build stronger patient relationships and improve their professional reputation."
        },
        {
          num : "3",
          path: "dhz",
          showData:false,
          img1:"http://116.62.38.250//image/nr/jjfa/1.jpg",
          img2:"http://116.62.38.250//image/nr/jjfa/2.jpg",
          img3:"http://116.62.38.250//image/nr/jjfa/3.jpg",
          text1:"Comfortable Diagnosis and Treatment Center",
          text2:"More Comfortable Experience: Compared to traditional treatment methods that may cause significant pain and discomfort, dental laser therapy often greatly reduces pain during the procedure, making it easier for patients to accept and undergo treatment.\n" +
            "Reduced Swelling and Pain: During surgery or treatment, lasers can cauterize small blood vessels, lymphatic vessels, and exposed nerve endings, thereby minimizing post-operative swelling and pain. This means smoother recovery for patients with less discomfort after treatment.\n" +
            "Faster Recovery Time: Since lasers cause minimal tissue damage and promote cellular repair and regeneration, patients can return to normal oral function more quickly, reducing the impact of treatment on daily life and work.\n" +
            "Lower Risk of Infection: The sterilizing effect of the laser helps eliminate pathogens, creating a cleaner treatment environment. This significantly reduces the risk of infection and can decrease the need for antibiotics.\n" +
            "Enhanced Aesthetic Results: In procedures involving cosmetic dental treatments, such as gum contouring or depigmentation, lasers offer more precise and natural-looking results, satisfying patients’ aesthetic expectations."
        }
      ]
    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  mounted() {
    let that = this;
    console.log("init");
    that.init();
  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'dyy')
      } else {
        let index = "1";
        if(that.urlData == 'dyy'){
          index = "1";
        } else if(that.urlData == 'dys'){
          index = "2";
        } else if(that.urlData == 'dhz'){
          index = "3";
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      // that.showData.box1 = false;
      for(let item in that.itemData){
         let sj = that.itemData[item]
        if(sj.num == index){
          sj.showData = true;
        } else {
          sj.showData = false;
        }
      }
      // that.showData.box1 = true;
      // if(index == '1'){
      //   that.showData.box1 = true;
      // }
    }
  }
}
</script>

<style scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.contentDetail{
  margin-top: 20px;
}
.itemContent{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
  white-space: pre-wrap;
  text-indent: 2em;
}
.leftImg{
  margin-top: 10px;
}
.rightTopImg{
  margin: 10px;
}
.contentImg{
  display: flex;
}
.contentTitle{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
  margin-top: 30px;
  margin-bottom: 20px;;
}
.contentBox {
  width: 1176px;
  margin: 50px auto;
}
.companyProfile {
  display: block;
  width: 1920px;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  height: 600px;
}

.imageItem {
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/en/companyProfile.vue